import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/*
This "guard" can be used to hide features until the devMode query parameter is set to "true".

Note: This should only be used for coordinating the release of new features.
Do not use this as a security mechanism!
 */
@Injectable()
export class InsecureDevMode {
  private isDev = false;
  constructor(route: ActivatedRoute) {
    route.queryParams.subscribe((params) => {
      const dm = String(params.devMode).toLowerCase();
      this.isDev = dm === 'true';
      if (this.isDev) {
        console.log('"In Development" components are now visible.');
      }
    });
  }
  isActive(): boolean {
    return this.isDev;
  }
}
